import { DocketEventInput } from '@oolio-group/domain';

export const processDocket = (event: DocketEventInput) => {
  if (!event?.payload) return;
  const docket = {
    orderId: event.payload.orgId,
    printerProfileId: event.payload.printerProfileId,
    id: event.payload.id,
    orgId: event.payload.orgId,
    storeId: event.payload.storeId,
    venueId: event.payload.venueId,
    status: event.payload.status,
    orderNumber: event.payload.orderNumber,
    table: event.payload.table,
    guestCount: event.payload.guestCount,
    section: event.payload.section,
    customer: event.payload.customer,
    orderType: event.payload.orderType,
    notes: event.payload.notes,
    createdAt: event.payload.createdAt,
    salesChannel: event.payload.salesChannel,
    docketItems: [],
  };
  return docket;
};
